const parseNumber = (value) => {
  if (value === '') {
    return ''
  }
  return +value.toString().replace(/[^\d.]/g, '')
}

const createPercentageMask = (value) => {
  const strippedVal = value.toString().replace('%', '')
  const regex = Array(strippedVal.length).fill(/\d/)
  return [...regex, '%']
}

export {
  parseNumber,
  createPercentageMask
}
